export default __webpack_public_path__ + "static/media/Semcasting_Archer_RGB_White.fc3e7743.png";